export { default } from "./useArticleGetByContentId";
